var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('identity-verification-form',{attrs:{"form-model":_vm.formModel,"person-title":_vm.local.bankruptcy.debtorForm.debtor,"view-mode":_vm.loading,"is-table-data":_vm.isTableData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }